import * as actionTypes from '../actions/actionTypes';

const initialState = {
    sub_package_list: [],
    loading: null,
    error: null
};

const reducer = (state = initialState, action) => {
    switch(action.type){
        case actionTypes.SUB_PACKAGES_LOADING:
            return {
                ...state,
                loading: true,
                error: null,
                sub_package_list: []
            };
        case actionTypes.SUB_PACKAGES_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error,
                sub_package_list: []
            };
        case actionTypes.SUB_PACKAGES_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                sub_package_list: action.payload
            };
        default:
            return state;
    }
};

export default reducer;